"use client";

import React from "react";
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuItem,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";

interface DropdownItem {
  label: string;
  value: string;
  color?: string;
  icon?: React.ReactNode;
}

interface DropdownSelectorProps {
  items: DropdownItem[];
  selected: string;
  onSelect: (value: string) => void;
  iconOnly?: boolean;
  label?: string;
  renderIcon?: (item: DropdownItem) => React.ReactNode;
}

export default function DropdownSelector({
  items,
  selected,
  onSelect,
  label = "Select",
  renderIcon,
}: DropdownSelectorProps) {
  const current = items.find((item) => item.value === selected);

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="outline"
          size="icon"
          className="w-10 h-10 p-0 flex items-center justify-center  backdrop-blur-sm hover:bg-gray-100  transition-colors"
        >
          {renderIcon && current
            ? renderIcon(current)
            : current?.label}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        className="w-48 max-h-[300px] overflow-y-auto rounded-xl bg-background/95 backdrop-blur-md shadow-lg "
        align="end"
      >
        <DropdownMenuLabel className="text-foreground">{label}</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {items.map((item) => (
          <DropdownMenuItem
            key={item.value}
            onSelect={() => onSelect(item.value)}
            className="text-foreground hover:bg-accent hover:text-accent-foreground"
          >
            {renderIcon ? (
              <>
                <span className="mr-2">{renderIcon(item)}</span>
                {item.label}
              </>
            ) : (
              item.label
            )}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
